interface FileIconProps {
  filename: string
  size?: number
}

export function FileIcon({ filename, size = 40 }: FileIconProps) {
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  
  // Determine file type and color
  const getFileTypeInfo = (extension: string) => {
    // Documents
    if (['pdf'].includes(extension)) {
      return { color: '#FF3B30', icon: 'doc' }
    }
    if (['doc', 'docx'].includes(extension)) {
      return { color: '#2B5797', icon: 'doc' }
    }
    if (['xls', 'xlsx', 'csv'].includes(extension)) {
      return { color: '#217346', icon: 'sheet' }
    }
    if (['ppt', 'pptx'].includes(extension)) {
      return { color: '#D24726', icon: 'slides' }
    }
    
    // Images
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'].includes(extension)) {
      return { color: '#A855F7', icon: 'image' }
    }
    
    // Video
    if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
      return { color: '#EF4444', icon: 'video' }
    }
    
    // Audio
    if (['mp3', 'wav', 'flac', 'aac', 'm4a', 'ogg'].includes(extension)) {
      return { color: '#EC4899', icon: 'audio' }
    }
    
    // Archives
    if (['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)) {
      return { color: '#F59E0B', icon: 'archive' }
    }
    
    // Code
    if (['js', 'ts', 'jsx', 'tsx', 'py', 'rb', 'go', 'rs', 'java', 'c', 'cpp', 'h', 'html', 'css', 'json', 'xml', 'yaml', 'yml', 'md'].includes(extension)) {
      return { color: '#10B981', icon: 'code' }
    }
    
    // Default
    return { color: '#6B7280', icon: 'file' }
  }
  
  const { color } = getFileTypeInfo(ext)
  
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: 'var(--radius-sm)',
      background: `${color}20`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none">
        <path
          d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
          stroke={color}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M14 2V8H20"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
